export const TEST_IDS = {
    arrowNext: 'carousel__arrow-next',
    arrowPrev: 'carousel__arrow-prev',
    pagination: 'carousel__pagination',
    trackLine: 'carousel__track-line',
    trackItem: 'carousel__track-item',
};
